import { z } from 'zod';
/**
 * Shared shapes for the initial-setup bulk validate endpoints
 * (org-functions, systems, processes).
 *
 * Row issues carry ErrorCode values instead of prose so the frontend can
 * translate them; `field` names the offending column and `metadata` feeds
 * message interpolation (e.g. { email }).
 */ export const RowIssueSchema = z.object({
    code: z.string(),
    field: z.string().optional(),
    metadata: z.record(z.string(), z.unknown()).optional()
});
/**
 * Wraps a per-row data schema into the validated-row envelope used by every
 * initialize validate endpoint. `data` echoes the input row plus any resolved
 * ids so the frontend can render resolution results without re-deriving them.
 */ export function makeValidatedRowSchema(dataSchema) {
    return z.object({
        rowNumber: z.number(),
        data: dataSchema,
        isValid: z.boolean(),
        errors: z.array(RowIssueSchema),
        warnings: z.array(RowIssueSchema)
    });
}
export const BulkValidationSummarySchema = z.object({
    batchValid: z.boolean(),
    totalRows: z.number(),
    validRows: z.number(),
    invalidRows: z.number()
});

//# sourceMappingURL=bulk-validation.schema.js.map